import { IconButton, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

import { typeChildFigurant } from 'components/modules/FigurantCard/constants';
import { Typography } from 'components/elements';
import { addLeadingZeros } from 'commons/utils';
import { StatusFigurant } from 'pages/SearchFigurant/@types';
import * as S from '../../styles';

type Props = {
  type: string;
  selectedFigurant: StatusFigurant[];
  textAction: string;
  totalFigurant: number;
  ExpandIcon: OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
    muiName: string;
  };
  toggleDrawer: () => void;
};

export const Header = ({ type, selectedFigurant, textAction, totalFigurant, ExpandIcon, toggleDrawer }: Props) => {
  return (
    <S.Header>
      <S.Column>
        {type !== typeChildFigurant && (
          <Typography sx={{ fontSize: '14px' }}>
            <S.Bold>{`${addLeadingZeros(selectedFigurant?.length, 2) || '00'} Figurante(s) `}</S.Bold>
            {`${textAction} ${totalFigurant ? `(do total de ${totalFigurant})` : ''}`}
          </Typography>
        )}
        {type === typeChildFigurant && (
          <Typography sx={{ fontSize: '14px' }}>
            <S.Bold>{`${addLeadingZeros(selectedFigurant?.length, 2) || '00'} Fiscais escalados`}</S.Bold>
          </Typography>
        )}
      </S.Column>
      <S.Column>
        <IconButton data-testid="button-to-open-modal" onClick={toggleDrawer} sx={{ backgroundColor: '#EFEFEF' }}>
          <ExpandIcon htmlColor="#ADADAD" />
        </IconButton>
      </S.Column>
    </S.Header>
  );
};
